import{mergeStyles as t}from"@fluentui/react";const i=t({opacity:0}),o=t({opacity:1,transition:"opacity 300ms ease-in"}),a=t({opacity:1}),c=t({opacity:0,transition:"opacity 300ms ease-out"});export{i as fadeEnter,o as fadeEnterActive,a as fadeExit,c as fadeExitActive};
//# sourceMappingURL=transitions.js.map
